function init(){
    var url = '/Handler/HvD/GlobalConf';
    var dlgFoot = $('#dlg-footer-edit').dialog({
        autoOpen: false,
        modal: true,
        height: 450,
        width: 700,
        buttons: [{
            text: "Schließen",
            class: "cancel",
            click: function() {
                $(this).dialog("close");
            }
        }, {
            text: "Speichern",
            class: "ok",
            click: function() {
                var fields = dlgFoot.find('input, select');
                var postData = Array();
                fields.each(function(i, el) {
                    var item = {
                        name: el.name,
                        value: el.value
                    };
                    postData.push(item);
                });
                var data = {
                    data: {
                        type: 'save',
                        fields: postData
                    }
                };
                $.ajax({
                    type: "POST",
                    url: url,
                    data: data
                }).done(function(data) {
                    if (data == 'ok') {
                        dlgFoot.dialog("close");
                        tools.toast('Footer', 'Daten gespeichert');
                        var $f = $('#footer a');
                        var dlgData = dlgFoot.find('.form-horizontal.container-fluid');
                        for (var i = 0; i < $f.length; i++) {
                            console.debug($f[i]);
                            $f[i].text = $(dlgData[i]).find('input')[0].value;
                            $f[i].href = $(dlgData[i]).find('input')[1].value;
                            $f[i].target = $(dlgData[i]).find('select')[0].value;
                        }
                        //location.reload();
                    }
                });
            }
        }]
    });

    $('.edit-footer').on('click', (function(event) {
        dlgFoot.dialog("open");
    }));

}
window.setTimeout(init, 200);
